
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[uuid]",
      function () {
        return require("private-next-pages/shops/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[uuid]"])
      });
    }
  